import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import RequiredLabel from "../RequiredLabel";

const Steps3 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const initialErrorData = {
    flat_society: "",
    country: "",
    state: "",
    district: "",
    city: "",
  };

  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState(initialErrorData);
  const [showInfo, setShowInfo] = useState(false);

  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allDistrict, setAllDistrict] = useState([]);
  const [allTaluka, setAllTaluka] = useState([]);
  const [allCityTown, setAllCityTown] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedCityTown, setSelectedCityTown] = useState("");
  var userMemberId = localStorage.getItem("aimsUserMemberId");
  useEffect(() => {
    console.log(details);
    console.log(formData, "=================");
    setFormData(details);
    console.log(formData, "=================11111");
  }, [details]);
  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      if (name === "presentAddressDiffrent") {
        setFormData({ ...formData, [name]: e.target.checked });
        setShowInfo(e.target.checked);
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }

    // Clear errors for the field if it is filled
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    // Permanent Address Validation
    if (!formData.flat_society || formData.flat_society.trim() === "") {
      newErrors.flat_society = "Please enter Flat / Society";
      isValid = false;
    }

    if (!formData.country || formData.country.trim() === "") {
      newErrors.country = "Please select Country";
      isValid = false;
    }

    if (!formData.state || formData.state.trim() === "") {
      newErrors.state = "Please select State";
      isValid = false;
    }

    if (!formData.district || formData.district.trim() === "") {
      newErrors.district = "Please select District";
      isValid = false;
    }

    if (!formData.city || formData.city.trim() === "") {
      newErrors.city = "Please enter Town/City";
      isValid = false;
    }

    // Present Address Validation (if showInfo is true)
    if (showInfo) {
      if (
        !formData.present_flat_society ||
        formData.present_flat_society.trim() === ""
      ) {
        newErrors.present_flat_society = "Please enter Present Flat / Society";
        isValid = false;
      }

      if (!formData.present_country || formData.present_country.trim() === "") {
        newErrors.present_country = "Please select Present Country";
        isValid = false;
      }

      if (!formData.present_state || formData.present_state.trim() === "") {
        newErrors.present_state = "Please select Present State";
        isValid = false;
      }

      if (
        !formData.present_district ||
        formData.present_district.trim() === ""
      ) {
        newErrors.present_district = "Please select Present District";
        isValid = false;
      }

      if (!formData.present_city || formData.present_city.trim() === "") {
        newErrors.present_city = "Please enter Present Town/City";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    if (formData?.pincode?.length === 6) {
      axios
        .post(
          `https://anoopam.com/aims/api/?pincode=${formData?.pincode}&formate=new`
        )
        .then((res) => {
          const uniqueCountries = [
            ...new Set(res?.data.map((item) => item.Country)),
          ];
          const uniqueState = [...new Set(res?.data.map((item) => item.State))];
          const uniqueDistrict = [
            ...new Set(res?.data.map((item) => item.District)),
          ];
          const uniqueTaluka = [
            ...new Set(res?.data.map((item) => item.Block)),
          ];
          const uniqueCityTown = [
            ...new Set(res?.data.map((item) => item.Name)),
          ];

          setAllCountry(uniqueCountries);
          setAllState(uniqueState);
          setAllDistrict(uniqueDistrict);
          setAllTaluka(uniqueTaluka);
          setAllCityTown(uniqueCityTown);

          if (uniqueCountries.length > 0) {
            setFormData((prev) => ({
              ...prev,
              country: uniqueCountries[0],
              state: uniqueState[0] || "",
              district: uniqueDistrict[0] || "",
              city: uniqueCityTown[0] || "",
            }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setAllCountry([]);
      setAllState([]);
      setAllDistrict([]);
      setAllTaluka([]);
      setAllCityTown([]);
    }
  }, [formData?.pincode]);

  useEffect(() => {
    if (formData?.present_pincode?.length === 6 && showInfo) {
      axios
        .post(
          `https://anoopam.com/aims/api/?pincode=${formData?.present_pincode}&formate=new`
        )
        .then((res) => {
          const uniqueCountries = [
            ...new Set(res?.data.map((item) => item.Country)),
          ];
          const uniqueState = [...new Set(res?.data.map((item) => item.State))];
          const uniqueDistrict = [
            ...new Set(res?.data.map((item) => item.District)),
          ];
          const uniqueTaluka = [
            ...new Set(res?.data.map((item) => item.Block)),
          ];
          const uniqueCityTown = [
            ...new Set(res?.data.map((item) => item.Name)),
          ];

          setAllCountry(uniqueCountries);
          setAllState(uniqueState);
          setAllDistrict(uniqueDistrict);
          setAllTaluka(uniqueTaluka);
          setAllCityTown(uniqueCityTown);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [formData?.present_pincode, showInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const transformedData = {
        permanent_address: {
          Addresstype: formData.addresstype,
          Pincode: formData.pincode,
          Country: formData.country,
          State: formData.state,
          District: formData.district,
          Taluka: formData.taluka,
          Town_City: formData.city,
          House_no: formData.house_no,
          Flat_socirty: formData.flat_society,
          Near_by: formData.nearby,
        },
        Available_time_anything: formData.availableTime,
        Sameaddress: !showInfo,
        Remark: formData.remark,
        current_address: showInfo
          ? {
              Addresstype: formData.addresstype,
              Pincode: formData.present_pincode,
              Country: formData.present_country,
              State: formData.present_state,
              District: formData.present_district,
              Taluka: formData.present_taluka,
              Town_City: formData.present_city,
              House_no: formData.present_house_no,
              Flat_socirty: formData.present_flat_society,
              Near_by: formData.present_nearby,
            }
          : {
              Addresstype: formData.addresstype,
              Pincode: formData.pincode,
              Country: formData.country,
              State: formData.state,
              District: formData.district,
              Taluka: formData.taluka,
              Town_City: formData.city,
              House_no: formData.house_no,
              Flat_socirty: formData.flat_society,
              Near_by: formData.nearby,
            },
      };
      // console.log("Transformed Data:", transformedData);
      detailsSet(formData);
      sendAddressDEtails(transformedData); // Uncomment this to send data to API
    }
  };

  const sendAddressDEtails = (el) => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=addressdetails&memberid=${userMemberId}`,
        { ...el }
      )
      .then((res) => {
        // console.log(res?.data);
        if (res?.data?.status === "success") {
          Swal.fire({
            text: `${res?.data?.msg}`,
            icon: "success",
          });
          setCount(count + 1);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error",
        });
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="mt-4 main p-4 border rounded-4  bg-white">
          <div className="row   ">
            {/* address */}
            <div className="col-11 mt-3">
              <label className="tittle-text">Address Type</label>
              <div className="d-flex gap-3 flex-wrap mt-2">
                {["Home", "Office"].map((addresstype, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      name="addresstype"
                      id={`addresstype-${index}`}
                      type="radio"
                      value={addresstype}
                      onChange={handleInputChange}
                      checked={formData?.addresstype === addresstype}
                    />
                    <label
                      htmlFor={`addresstype-${index}`}
                      className={`btn rounded-5 button1 ${
                        formData?.addresstype === addresstype ? "active" : ""
                      }`}
                    >
                      {addresstype}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="mt-3 col-lg-2">
              <label className="tittle-text" htmlFor="pincode">
                {" "}
                Pin Code
              </label>
              <input
                name="pincode"
                value={formData?.pincode || ""}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Pin Code"
                className="form-control mt-2 "
              />
            </div>{" "}
            <div className="mt-3 col-lg-4">
              <RequiredLabel htmlFor="country">Country</RequiredLabel>
              <select
                name="country"
                value={formData?.country || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedCountry(e.target.value); // Store selected country
                }}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                {/* Dynamic options from library */}
                <option value="">Select...</option>
                {allCountry?.map((country, i) => (
                  <option key={i} value={country}>
                    {country}
                  </option>
                ))}
              </select>

              {errors?.country && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.country}
                </span>
              )}
            </div>{" "}
            <div className="mt-3 col-lg-3">
              <RequiredLabel htmlFor="state">State</RequiredLabel>
              <select
                name="state"
                value={formData?.state || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedState(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example"
              >
                <option value="">Select...</option>
                {allState?.map((state, i) => (
                  <option key={i} value={state}>
                    {state}
                  </option>
                ))}
              </select>

              {errors?.state && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.state}
                </span>
              )}
            </div>
            <div className="mt-3 col-lg-3">
              <RequiredLabel htmlFor="district">District</RequiredLabel>
              <select
                name="district"
                value={formData?.district || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedDistrict(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="">Select...</option>
                {allDistrict?.map((dis, i) => (
                  <option key={i} value={dis}>
                    {dis}
                  </option>
                ))}
              </select>
              {errors?.district && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.district}
                </span>
              )}
            </div>{" "}
            <div className="mt-3 col-lg-6">
              <label className="tittle-text" htmlFor="taluka">
                {" "}
                Taluka
              </label>
              <select
                name="taluka"
                value={formData?.taluka || ""}
                onChange={handleInputChange}
                className="form-select mt-2"
                aria-label="Default select example  "
              >
                <option value="">Select...</option>
                {allTaluka?.map((taluka, i) => (
                  <option key={i} value={taluka}>
                    {taluka}
                  </option>
                ))}
              </select>
            </div>{" "}
            {/* City Dropdown */}
            <div className="mt-3 col-lg-6">
              <RequiredLabel htmlFor="city">Town/City</RequiredLabel>
              <select
                name="city"
                value={formData?.city || ""}
                onChange={(e) => {
                  handleInputChange(e);
                  setSelectedCityTown(e.target.value);
                }}
                className="form-select mt-2"
                aria-label="Default select example"
              >
                <option value="">Select...</option>
                {allCityTown?.map((city, i) => (
                  <option key={i} value={city}>
                    {city}
                  </option>
                ))}
              </select>
              {errors?.city && (
                <span className="text-danger fw-medium d-inline-flex">
                  {errors?.city}
                </span>
              )}
              <div className="mt-3"></div>
            </div>
            <div className=" col-lg-2">
              <label className="tittle-text" htmlFor="house_no">
                {" "}
                House No.
              </label>
              <input
                type="text"
                name="house_no"
                value={formData?.house_no || ""}
                onChange={handleInputChange}
                placeholder="Enter House No."
                className="form-control mt-2 "
              />
            </div>
            <div className=" col-lg-5">
              <RequiredLabel htmlFor="flat_society">
                Flat / Society
              </RequiredLabel>
              <input
                name="flat_society"
                value={formData?.flat_society || ""}
                onChange={handleInputChange}
                type="text"
                placeholder="Enter Your Flat / Society Name"
                className="form-control mt-2 "
              />
              {errors?.flat_society && (
                <span className="text-danger  fw-medium d-inline-flex">
                  {errors?.flat_society}
                </span>
              )}
            </div>{" "}
            <div className=" col-lg-5">
              <label className="tittle-text" htmlFor="nearby">
                {" "}
                Near by
              </label>
              <input
                type="text"
                name="nearby"
                value={formData?.nearby || ""}
                onChange={handleInputChange}
                placeholder=""
                className="form-control mt-2 "
              />
            </div>{" "}
            {/* Present address is different */}
            <div className=" mt-3">
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="presentAddressDiffrent"
                  name="presentAddressDiffrent"
                  checked={showInfo}
                  onChange={handleInputChange}
                />

                <label className="mx-2 tittle-text" htmlFor="present_address">
                  Present address is different
                </label>
              </div>
            </div>
            {/* diffrent address */}
            {showInfo && (
              <div>
                <div className="mt-3 col-lg-2">
                  <label className="tittle-text" htmlFor="present_pincode">
                    {" "}
                    Present Pin Code
                  </label>
                  <input
                    name="present_pincode"
                    value={formData?.present_pincode || ""}
                    onChange={handleInputChange}
                    type="text"
                    placeholder="Enter Present Pin Code"
                    className="form-control mt-2 "
                  />
                </div>{" "}
                {/* <div className="mt-3 col-md-3"> */}
                <div className="mt-3 col-lg-4">
                  <RequiredLabel htmlFor="present_country">
                    Present Country
                  </RequiredLabel>
                  <select
                    name="present_country"
                    value={formData?.present_country || ""}
                    onChange={handleInputChange}
                    className="form-select mt-2"
                    aria-label="Default select example  "
                  >
                    {/* Dynamic options from library */}
                    <option value="">Select...</option>
                    {allCountry?.map((country, i) => (
                      <option key={i} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>

                  {errors?.country && (
                    <span className="text-danger fw-medium d-inline-flex">
                      {errors?.country}
                    </span>
                  )}
                </div>{" "}
                <div className="mt-3 col-lg-3">
                  <RequiredLabel htmlFor="present_state">
                    Present State
                  </RequiredLabel>
                  <select
                    name="present_state"
                    value={formData?.present_state || ""}
                    onChange={handleInputChange}
                    className="form-select mt-2"
                    aria-label="Default select example"
                  >
                    <option value="">Select...</option>
                    {allState?.map((state, i) => (
                      <option key={i} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>

                  {errors?.state && (
                    <span className="text-danger fw-medium d-inline-flex">
                      {errors?.state}
                    </span>
                  )}
                </div>
                <div className="mt-3 col-lg-3">
                  <RequiredLabel htmlFor="present_district">
                    Present District
                  </RequiredLabel>
                  <select
                    name="present_district"
                    value={formData?.present_district || ""}
                    onChange={handleInputChange}
                    className="form-select mt-2"
                    aria-label="Default select example  "
                  >
                    <option value="">Select...</option>
                    {allDistrict?.map((dis, i) => (
                      <option key={i} value={dis}>
                        {dis}
                      </option>
                    ))}
                  </select>
                  {errors?.district && (
                    <span className="text-danger  fw-medium d-inline-flex">
                      {errors?.district}
                    </span>
                  )}
                </div>{" "}
                <div className="mt-3 col-lg-6">
                  <label className="tittle-text" htmlFor="present_taluka">
                    {" "}
                    Present Taluka
                  </label>
                  <select
                    name="present_taluka"
                    value={formData?.present_taluka || ""}
                    onChange={handleInputChange}
                    className="form-select mt-2"
                    aria-label="Default select example  "
                  >
                    <option value="">Select...</option>
                    {allTaluka?.map((taluka, i) => (
                      <option key={i} value={taluka}>
                        {taluka}
                      </option>
                    ))}
                  </select>
                </div>{" "}
                {/* City Dropdown */}
                <div className="mt-3 col-lg-6">
                  <RequiredLabel htmlFor="present_city">
                    Present Town/City
                  </RequiredLabel>
                  <select
                    name="present_city"
                    value={formData?.present_city || ""}
                    onChange={handleInputChange}
                    className="form-select mt-2"
                    aria-label="Default select example"
                  >
                    <option value="">Select...</option>
                    {allCityTown?.map((city, i) => (
                      <option key={i} value={city}>
                        {city}
                      </option>
                    ))}
                  </select>
                  {errors?.city && (
                    <span className="text-danger fw-medium d-inline-flex">
                      {errors?.city}
                    </span>
                  )}
                  <div className="mt-3"></div>
                </div>
                <div className=" col-lg-2">
                  <label className="tittle-text" htmlFor="present_house_no">
                    {" "}
                    Present House No.
                  </label>
                  <input
                    type="text"
                    name="present_house_no"
                    value={formData?.present_house_no || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Present House No."
                    className="form-control mt-2 "
                  />
                </div>
                <div className=" col-lg-5">
                  <RequiredLabel htmlFor="present_flat_society">
                    Present Flat / Society
                  </RequiredLabel>
                  <input
                    name="present_flat_society"
                    value={formData?.present_flat_society || ""}
                    onChange={handleInputChange}
                    type="text"
                    placeholder="Enter Present Flat / Society Name"
                    className="form-control mt-2 "
                  />
                  {errors?.flat_society && (
                    <span className="text-danger  fw-medium d-inline-flex">
                      {errors?.flat_society}
                    </span>
                  )}
                </div>{" "}
                <div className=" col-lg-5">
                  <label className="tittle-text" htmlFor="present_nearby">
                    {" "}
                    Present Near by
                  </label>
                  <input
                    type="text"
                    name="present_nearby"
                    value={formData?.present_nearby || ""}
                    onChange={handleInputChange}
                    placeholder=""
                    className="form-control mt-2 "
                  />
                </div>{" "}
              </div>
            )}
            <div className="col-12 mt-3">
              <label className="tittle-text" htmlFor="availableTime">
                Available time or anything
              </label>
              <div className="form-floating mt-2">
                <textarea
                  name="availableTime"
                  value={formData?.availableTime}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Select ..."
                  id="floatingTextarea"
                ></textarea>
              </div>
            </div>
            {/* Remark Input */}
            <div className="col-12 mt-3">
              <label className="tittle-text" htmlFor="remark">
                Remark
              </label>
              <div className="form-floating mt-2">
                <textarea
                  name="remark"
                  value={formData?.remark}
                  onChange={handleInputChange}
                  className="form-control"
                  placeholder="Enter any Remarks"
                  id="floatingRemark"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-3 mt-3">
          {count !== 0 && (
            <button
              className="rounded-5 btnBlue"
              onClick={() => setCount(count - 1)}
            >
              Previous
            </button>
          )}
          {count < 5 && (
            <button type="submit" className="rounded-5 btnBlue">
              Next
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default Steps3;
